import {Roles} from "../helpers/roles";

export const menuItems = [

    /* =======================
     * DASHBOARD
     * ======================= */
    {
        label: 'Dashboard',
        icon: 'fe fe-home',
        route: 'adminDashboard',
        roles: [Roles.ADMIN, Roles.PROJET, Roles.COMMUNICATION]
    },

    /* =======================
     * CONTENUS INSTITUTIONNELS
     * ======================= */
    {
        label: 'Contenus',
        icon: 'fe fe-file-text',
        roles: [Roles.ADMIN, Roles.COMMUNICATION],
        children: [
            {
                label: 'Actualités',
                route: 'adminNews',
                permission: 'NEWS_MANAGE'
            },
            {
                label: 'Bannières',
                route: 'adminBanners',
                permission: 'BANNERS_MANAGE'
            },
            {
                label: 'Communiqués',
                route: 'adminCommuniques',
                permission: 'COMMUNIQUES_MANAGE'
            }
        ]
    },

    /* =======================
     * PROJETS
     * ======================= */
    {
        label: 'Projets',
        icon: 'fe fe-layers',
        roles: [Roles.ADMIN, Roles.PORTAL_PROJET],
        children: [
            {
                label: 'Projets',
                route: 'adminProjects',
                permission: 'PROJECT_MANAGE'
            },
            {
                label: 'Axes & Actions',
                route: 'adminProjectAxes',
                permission: 'PROJECT_AXES_MANAGE'
            },
            {
                label: 'Timeline',
                route: 'adminProjectTimeline',
                permission: 'PROJECT_TIMELINE_MANAGE'
            },
            {
                label: 'Galerie Média',
                route: 'adminProjectMedia',
                permission: 'PROJECT_MEDIA_MANAGE'
            }
        ]
    },
    /* =======================
 * MARKET CATEGORY
 * ======================= */
    {
        label: 'Catégories de marché',
        icon: 'fe fe-grid',
        route: 'adminMarketCategories',
        roles: [
            Roles.ADMIN,
            Roles.PORTAL_MARKET,
            Roles.MARKET_CATEGORY_READ
        ]
    },


    /* =======================
  * MARKET TYPE
  * ======================= */
    {
        label: 'Types de marché',
        icon: 'fe fe-tag',
        route: 'adminMarketTypes',
        roles: [
            Roles.ADMIN,
            Roles.PORTAL_MARKET,
            Roles.MARKET_TYPE_READ
        ]
    },

    /* =======================
     * DOCUMENT TYPE
     * ======================= */
    {
        label: 'Types de documents',
        icon: 'fe fe-file',
        route: 'adminDocumentTypes',
        roles: [
            Roles.ADMIN,
            Roles.PORTAL_DOCUMENT,
            Roles.DOCUMENT_TYPE_READ
        ]
    },


    /* =======================
     * STATISTIQUES & PILOTAGE
     * ======================= */
    {
        label: 'Statistiques',
        icon: 'fe fe-bar-chart',
        roles: [Roles.ADMIN, Roles.PORTAL_PROJET],
        children: [
            {
                label: 'Indicateurs',
                route: 'adminIndicators',
                permission: 'INDICATORS_MANAGE'
            },
            {
                label: 'Compteurs',
                route: 'adminCounters',
                permission: 'COUNTERS_MANAGE'
            }
        ]
    },

    /* =======================
     * CARTE DES PROJETS
     * ======================= */
    {
        label: 'Carte des projets',
        icon: 'fe fe-map',
        route: 'adminProjectMap',
        roles: [Roles.ADMIN, Roles.PORTAL_PROJET],
        permission: 'PROJECT_MAP_VIEW'
    },

    /* =======================
     * PARTICIPATION CITOYENNE
     * ======================= */
    {
        label: 'Participation citoyenne',
        icon: 'fe fe-message-square',
        roles: [Roles.ADMIN, Roles.COMMUNICATION],
        children: [
            {
                label: 'Questions',
                route: 'adminQuestions',
                permission: 'QUESTIONS_MANAGE'
            },
            {
                label: 'Votes / Sondages',
                route: 'adminPolls',
                permission: 'POLLS_MANAGE'
            },
            {
                label: 'Idées',
                route: 'adminIdeas',
                permission: 'IDEAS_MANAGE'
            }
        ]
    },

    /* =======================
     * ÉVÉNEMENTS
     * ======================= */
    {
        label: 'Événements',
        icon: 'fe fe-calendar',
        roles: [Roles.ADMIN, Roles.COMMUNICATION],
        children: [
            {
                label: 'Événements',
                route: 'adminEvents',
                permission: 'EVENTS_MANAGE'
            },
            {
                label: 'Inscriptions',
                route: 'adminEventRegistrations',
                permission: 'EVENT_REGISTRATIONS_VIEW'
            }
        ]
    },

    /* =======================
     * ÉQUIPES & CONSULTANTS
     * ======================= */
    {
        label: 'Équipes & Consultants',
        icon: 'fe fe-users',
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'Équipes',
                route: 'adminTeams',
                permission: 'TEAMS_MANAGE'
            },
            {
                label: 'Consultants',
                route: 'adminConsultants',
                permission: 'CONSULTANTS_MANAGE'
            },
            {
                label: 'Compétences',
                route: 'adminSkills',
                permission: 'SKILLS_MANAGE'
            }
        ]
    },

    /* =======================
     * ADMINISTRATION
     * ======================= */
    {
        label: 'Administration',
        icon: 'fe fe-settings',
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'Utilisateurs',
                route: 'adminUsers',
                permission: 'USERS_MANAGE'
            },
            {
                label: 'Rôles & Permissions',
                route: 'adminRoles',
                permission: 'ROLES_MANAGE'
            },
            {
                label: 'Paramètres',
                route: 'adminSettings',
                permission: 'SETTINGS_MANAGE'
            }
        ]
    }

];
